function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { system, get } from "styled-system";
import { transformGridValue } from "./transforms";

var isNumber = function isNumber(n) {
  return typeof n === "number" && !isNaN(n);
};

var getWidth = function getWidth(n, scale) {
  return get(scale, n, !isNumber(n) || n > 1 ? n : n * 100 + "%");
};

var widthConfig = {
  property: "width",
  scale: "sizes",
  transform: function transform(value, scale) {
    return transformGridValue(getWidth(value, scale), scale);
  }
};

var minWidth = _extends({}, widthConfig, {
  property: "minWidth"
});

var maxWidth = _extends({}, widthConfig, {
  property: "maxWidth"
});

export var width = system({
  // dynamic grid units
  width: widthConfig,
  minWidth: minWidth,
  maxWidth: maxWidth
});
export default width;